import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute, NavigationStart } from '@angular/router';

@Component({
  selector: "app-user-management",
  templateUrl: "./user-management.component.html",
  styleUrls: ["./user-management.component.scss"]
})
export class UserManagementComponent implements OnInit {
  NAV_WEEK: string = 'false';
  NAV_COURSE: string = 'false';
  NAV_USER: string = 'true';

  constructor(private router: Router, route: ActivatedRoute) {
    router.events.subscribe((event) => {

      if (event instanceof NavigationStart) {
        ;
        if (event.url.startsWith("/main/user-management/view-user")) {
          this.NAV_COURSE = 'false';
          this.NAV_WEEK = 'false';
          this.NAV_USER = 'true';
        }
        if (event.url.startsWith("/main/user-management/view-userCourse")) {

          this.NAV_COURSE = 'true';
          this.NAV_USER = 'true';
          this.NAV_WEEK = 'false';
        }
        if (event.url.startsWith("/main/user-management/view-userLesson")) {
          this.NAV_COURSE = 'true';
          this.NAV_USER = 'true';
          this.NAV_WEEK = 'true';
        }
        if (event.url.startsWith("/main/user-management/view-userASR")) {
          this.NAV_COURSE = 'true';
          this.NAV_USER = 'true';
          this.NAV_WEEK = 'true';
        }


      }

    });
  }

  ngOnInit() { }
}
